import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PostFinanceAccountsService } from "@/features/accounts/finance/services/post-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { usePostFinanceAccountStates } from "@/features/accounts/finance/hooks/use-post-accounts-states";
import { useContext } from "react";


export const usePostFinanceAccount = () => {
  const {
    financeAccountId,
    setFinanceAccountId,
    finances,
    setFinances,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = usePostFinanceAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const postFinanceAccountsService = new PostFinanceAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関登録
  const registerFinanceAccounts = async (
    accountGroupId: string,
    financeAccountId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await postFinanceAccountsService.postFinanceAccounts({
        account_group_id: accountGroupId,
        finance_account_id: financeAccountId,
      });
      // 成功時の処理
      setFinances(res);
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("registerFinanceAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    financeAccountId,
    setFinanceAccountId,
    finances,
    setFinances,
    isShowErrorDialog,
    setIsShowErrorDialog,
    registerFinanceAccounts: errorHandledAsync(registerFinanceAccounts, setError),
  };
};
